import React from 'react'

interface IProps{
    onChange: any;
    steps: number;
}

const ConfigMapPolyline = ({steps, onChange}: IProps) => {
    return (
        <div>
              <label>Steps</label>
              <input type="number" min={1} max={10} value={steps} onChange={({ target }) => {

                if(+target.value > 0 && +target.value < 11){
                  onChange('steps', target.value)
                }
                else{
                  target.value = ''
                }
              }}/>

          </div>
    );
}

export default ConfigMapPolyline;

